import React from 'react';

import {
  ButtonTypeMap,
  CircularProgress,
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@mui/material';

type CustomButtonProps<C extends React.ElementType = ButtonTypeMap['defaultComponent']> = {
  component?: C;
  loading?: boolean;
  download?: string | undefined;
};

/** @deprecated Please use Button component from @mui/material */

export const Button = <C extends React.ElementType = ButtonTypeMap['defaultComponent']>({
  loading,
  onClick,
  sx,
  children,
  ...rest
}: MuiButtonProps<C> & CustomButtonProps<C>) => {
  const handleClick: NonNullable<MuiButtonProps['onClick']> = React.useCallback(
    event => {
      if (!loading) onClick?.(event);
    },
    [loading, onClick],
  );

  return (
    <MuiButton {...rest} onClick={handleClick} sx={loading ? { ...sx, color: 'transparent' } : sx}>
      {children}

      {loading && (
        <div style={circularProgressContainerStyles(rest.variant, rest.color)}>
          <CircularProgress color="inherit" size="1em" />
        </div>
      )}
    </MuiButton>
  );
};

export const circularProgressContainerStyles = (
  variant: MuiButtonProps['variant'],
  color: MuiButtonProps['color'],
): React.CSSProperties => {
  return {
    position: 'absolute',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    color:
      (color === 'primary' || color === 'secondary') && variant === 'contained' ? 'white' : 'black',
  };
};
